var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9746 1.58325L4.10876 4.457",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0254 1.58325L14.8912 4.457",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58331 6.21468C1.58331 4.7501 2.36706 4.63135 3.34081 4.63135H15.6591C16.6329 4.63135 17.4166 4.7501 17.4166 6.21468C17.4166 7.91676 16.6329 7.79801 15.6591 7.79801H3.34081C2.36706 7.79801 1.58331 7.91676 1.58331 6.21468Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72668 11.0833V13.8937",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3683 11.0833V13.8937",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77081 7.91675L3.88706 14.7567C4.1404 16.2926 4.74998 17.4167 7.01415 17.4167H11.7879C14.25 17.4167 14.6141 16.3401 14.8991 14.8517L16.2291 7.91675",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.f789facfba52a9bd6ec337f5c40556a6.svg";
export { ForwardRef as ReactComponent };